// @flow
import { HIDE_ESTIMATED_COST_MODAL, RECEIVE_POWER_CONSUMPTION, SHOW_ESTIMATED_COST_MODAL } from './constants';

import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';

const actionHandlers = {
    // $FlowFixMe
    [RECEIVE_POWER_CONSUMPTION]: handleReduce((state, { payload }) => state.set('average', payload.average)),
    // $FlowFixMe
    [SHOW_ESTIMATED_COST_MODAL]: handleReduce(state => state.set('showEstimatedCostModal', true)),
    // $FlowFixMe
    [HIDE_ESTIMATED_COST_MODAL]: handleReduce(state => state.set('showEstimatedCostModal', false))
};

export default handleActions(
    actionHandlers,
    fromJS({
        average: null,
        showEstimatedCostModal: false
    })
);



// WEBPACK FOOTER //
// ./src/core/state/power-consumption/index.js